import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import CloseButton from '../../common/CloseButton/CloseButton';
import InputBoxSmall from '../../common/InputBox/InputBoxSmall';
import '../../common/CommonText.css';
import { isRequired, isTextOnly } from '../../../validation';
import { showAlert } from '../../common/ExportLabel/Exporterror';
// const EditInternalUserRolesPopup = ({
//   isOpen,
//   title,
//   fields,
//   onSave,
//   onClose,
//   tableHeaders,
//   initialTableRows,
//   selected,
// }) => {
//   const [tableRows, setTableRows] = useState(initialTableRows);
//   const [formValues, setFormValues] = useState(selected);

//   useEffect(() => {
//     setFormValues(selected)
//   }, [selected]);

//   useEffect(() => {
//     setTableRows(initialTableRows);
// }, [initialTableRows]);

//   useEffect(() => {
//     if (!isOpen) {
//       setFormValues({});
//     }
//   }, [isOpen]);

//   const handleInputChange = (field, value) => {
//     setFormValues((prevValues) => ({
//       ...prevValues,
//       [field]: value,
//     }));
//   };

//   const handleCheckboxToggle = (permissionId) => {
//     setFormValues((prevValues) => {
//       const updatedPermissions = prevValues.permissions?.some(
//         (perm) => perm.id === permissionId
//       )
//         ? prevValues.permissions.filter((perm) => perm.id !== permissionId)
//         : [...(prevValues.permissions || []), { id: permissionId }];

//       return { ...prevValues, permissions: updatedPermissions };
//     });
//   };
//   const handleSubmit = () => {
//     const permissionIds = formValues.permissions.map((perm) => perm.id);
  
//     const formData = {
//       ...formValues,
//       permissions: permissionIds, 
//     };
  
//     onSave(formData); 
//   };
  

//   if (!isOpen) return null;

//   return (
//     <div className="popup-overlay">
//       <div className="popup popup1 internal-user-popup">
//         <CloseButton onClick={onClose} />
//         <div className="popup-name-button">
//           <h2 className="popup-name">{title}</h2>
//           <button className="popup-add-button white fts-15" onClick={handleSubmit}>
//             Save
//           </button>
//         </div>

//         <div className="add-input-box-container">
//           {fields.map((field, index) => {
//             switch (field.type) {
//               case 'small-input':
//               return (
//                 <InputBoxSmall
//                   key={index}
//                   {...field}
//                   value={formValues[field.name] ?? field.defaultValue ?? ''} 
//                   onChange={(e) => handleInputChange(field.name, e.target.value)}
//                 />
//               );
//               default:
//                 return null;
//             }
//           })}
//         </div>
//         {tableHeaders && tableHeaders.length > 0 && tableRows.length > 0 &&(
//           <div className="internal-user-table-container">
//             <div className="internal-user-table-scrollable">
//               <table className="internal-user-table">
//                 <thead className="internal-user-table-thead common-table-head">
//                   <tr className="internal-user-role-tr common-table-thead-tr">
//                     <th className="text-left">Permission</th>
//                     <th className="text-center">Add</th>
//                     <th className="text-center">Edit</th>
//                     <th className="text-center">List</th>
//                     <th className="text-center">Archive</th>
//                     <th className="text-center">Delete</th>
//                   </tr>
//                 </thead>
//                 <tbody className="internal-user-table-tbody">
//                   {tableRows.map((row, rowIndex) => (
//                     <tr key={rowIndex} className="internal-user-table-tbody-tr">
//                       <td>{row.feature_name}</td>
//                       {['add', 'edit', 'list', 'archive', 'delete'].map((accessName, colIndex) => {
//                         const permission = row.permissions.find(
//                           (perm) => perm.access_name === accessName
//                         );
//                         return (
//                           <td key={colIndex} className="text-center">
//                             {permission ? (
//                               <input
//                                 className="table-selectbox internal-user-table-checkbox"
//                                 type="checkbox"
//                                 checked={
//                                   formValues.permissions?.some(
//                                     (perm) => perm.id === permission.id
//                                   ) || false
//                                 }
//                                 onChange={() => handleCheckboxToggle(permission.id)}
//                               />
//                             ) : (
//                               <span>&nbsp;</span>
//                             )}
//                           </td>
//                         );
//                       })}
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// EditInternalUserRolesPopup.propTypes = {
//   isOpen: PropTypes.bool.isRequired,
//   title: PropTypes.string.isRequired,
//   fields: PropTypes.array.isRequired,
//   onSave: PropTypes.func.isRequired,
//   onClose: PropTypes.func.isRequired,
//   tableHeaders: PropTypes.arrayOf(PropTypes.string),
//   initialTableRows: PropTypes.arrayOf(PropTypes.array),
//   selected: PropTypes.object,
// };

// export default EditInternalUserRolesPopup;
const EditInternalUserRolesPopup = ({
  isOpen,
  title,
  fields,
  onSave,
  onClose,
  tableHeaders,
  initialTableRows,
  popupErrorMessage,
  selected,
}) => {
  const [tableRows, setTableRows] = useState(initialTableRows);
  const [formValues, setFormValues] = useState(selected);
  const [formData, setFormData] = useState({})
  const [formErrors, setFormErrors] = useState({});

  useEffect(() => {
    setFormValues(selected);
  }, [selected]);

  useEffect(() => {
    setTableRows(initialTableRows);
  }, [initialTableRows]);

  useEffect(() => {
    if (!isOpen) {
      setFormValues({});
    }
  }, [isOpen]);

  const handleInputChange = (field, value) => {
    setFormData((prevValues) => ({
      ...prevValues,
      [field]: value,
    }));
  };

  const handleCheckboxToggle = (permissionId) => {
    setFormValues((prevValues) => {
      const exists = prevValues.permissions?.some((perm) => perm.id === permissionId);
      const updatedPermissions = exists
        ? prevValues.permissions.filter((perm) => perm.id !== permissionId)
        : [...(prevValues.permissions || []), { id: permissionId }];
  
      // Now update formData based on new formValues
      setFormData((prevFormData) => ({
        ...prevFormData,
        permissions: updatedPermissions,
      }));
  
      return {
        ...prevValues,
        permissions: updatedPermissions,
      };
    });
  };
  
  
  const validateField = (field) => {
    const validators = field.validators || [];
    const value = formData[field.name] || "";

    for (const validator of validators) {
      const result = validator(value);
      if (typeof result === "string") {
        return result;
      }
    }

    return null;
  };

  const handleSubmit = () => {
    
    const errors = {};
    let hasErrors = false;
  
    fields.forEach(field => {
      const error = validateField(field);
      if (error) {
        errors[field.name] = error;
        hasErrors = true;
      }
    });
  
    const finalPermissions =
      formData.permissions?.length > 0
        ? formData.permissions
        : formValues.permissions || [];
  
    const permissionIds = finalPermissions.map((perm) => perm.id);

    if (permissionIds.length === 0) {
          showAlert("Please select at least one permission.");
          return;
        }
    
    setFormErrors(errors);
  
    if (hasErrors) return;

    const finalData = {
      ...formValues,
      ...formData,
      permissions: permissionIds,
    };
  
    onSave(finalData);
   
  };

  const handleClose = () => {

    setFormErrors({});
    setFormValues({});
    setFormData({});

    if (onClose) onClose();
  };
  

  if (!isOpen) return null;

  return (
    <div className="popup-overlay">
      <div className="popup popup1 internal-user-popup">
        <CloseButton onClick={handleClose} />
        {popupErrorMessage && (
          <div className="popup-error-message" style={{ color: 'red', marginBottom: '10px' }}>
            {popupErrorMessage}
          </div>
        )}
        <div className="popup-name-button">
          <h2 className="popup-name">{title}</h2>
          <button className="popup-add-button white fts-15" onClick={handleSubmit}>
            Save
          </button>
        </div>

        <div className="add-input-box-container edit-popup">
          {fields.map((field, index) => {
            switch (field.type) {
                case 'small-input':
                  return (
                    <div key={index} className="field-container w-50">
                      <InputBoxSmall
                        key={index}
                        {...field}
                        value={formValues[field.name]}
                        onChange={(e) => handleInputChange(field.name, e.target.value)}
                        validators={isRequired}
                        error={formErrors[field.name]}
                      />
                    </div>
                  );

              default:
                return null;
            }
          })}
        </div>

        {tableHeaders && tableHeaders.length > 0 && tableRows.length > 0 && (
          <div className="internal-user-table-container">
            <div className="internal-user-table-scrollable">
              <table className="internal-user-table">
                <thead className="internal-user-table-thead common-table-head">
                  <tr className="internal-user-role-tr common-table-thead-tr">
                    <th className="text-left">Permission</th>
                    <th className="text-center">View</th>
                    <th className="text-center">View All</th>
                    <th className="text-center">Add</th>
                    <th className="text-center">Edit</th>
                    <th className="text-center">Archive</th>
                    <th className="text-center">Delete</th>
                  </tr>
                </thead>
                <tbody className="internal-user-table-tbody">
                  {tableRows.map((row, rowIndex) => (
                    <tr key={rowIndex} className="internal-user-table-tbody-tr">
                      <td>{row.feature_name
                          .replace(/_/g, ' ')
                          .split(' ')
                          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                          .join(' ')}
                        </td>
                      {["view","view_all","add", "edit", "archive", "delete"].map((accessName, colIndex) => {
                        const permission = row.permissions.find(
                          (perm) => perm.access_name === accessName
                        );
                        return (
                          <td key={colIndex} className="text-center ">
                            {permission ? (
                              <input
                                className="table-selectbox internal-user-table-checkbox "
                                type="checkbox"
                                checked={
                                  formValues.permissions?.some(
                                    (perm) => perm.id === permission.id
                                  ) || false
                                }
                                onChange={() => handleCheckboxToggle(permission.id)}
                              />
                            ) : (
                              <span>&nbsp;</span>
                            )}
                          </td>
                        );
                      })}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

EditInternalUserRolesPopup.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  fields: PropTypes.array.isRequired,
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  tableHeaders: PropTypes.arrayOf(PropTypes.string),
  initialTableRows: PropTypes.arrayOf(PropTypes.array),
  selected: PropTypes.object,
};

export default EditInternalUserRolesPopup;
